import React, { Component } from 'react';
import { connect } from 'react-redux';
import { difference, union } from 'lodash';
import { Text } from '../../components/Text';
import { DynamicWrapper } from '../../components/util/DynamicWrapper';
import { MultipleChoiceControl } from '../../components/controls/MultipleChoiceControl';
import { backOnboarding, continueOnboarding, pathAware } from '../../actions/onboardingActions';

class SavingGoals extends Component {
  constructor(props) {
    super(props);
    this.state = { savingGoals: props.qna_hash.savingGoals ? props.qna_hash.savingGoals.answer : [] };
  }

  componentDidMount() {
    this.props.pathAware('savingGoals');
  }

  componentWillReceiveProps(props) {
    if (props.qna_hash.savingGoals) {
      this.setState({
        savingGoals: props.qna_hash.savingGoals.answer,
      });
    }
  }

  _onContinue = () => {
    const { onContinue, qna_hash, qna_stack } = this.props;

    this.props
      .continueOnboarding(qna_stack, qna_hash, {
        savingGoals: {
          question: 'What are you saving up for?',
          answer: this.state.savingGoals,
        },
      })
      .then(onContinue);
  };

  _onBack = () => {
    this.props.backOnboarding(this.props.qna_stack).then(this.props.onBack);
  };

  onChange = (value, isSelected) => {
    const method = isSelected ? union : difference;
    this.setState({ savingGoals: method(this.state.savingGoals, [value]) });
  };

  render() {
    const { qna_hash, wrapper } = this.props;
    const { savingGoals } = this.state;

    return (
      <DynamicWrapper
        style={{ width: '100%' }}
        wrapper={wrapper}
        onContinue={this._onContinue}
        onBack={this._onBack}
        canContinue
      >
        <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
          <Text use="headline6">What are you saving up for?</Text>
        </div>
        <div
          style={{ width: '90%', margin: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
        >
          <Text className="mb-0" use="body1">
            Select up to 3 dream purchases from the list below.
          </Text>
          <Text className="mb-0" use="body1">
            Don't worry about general living expenses and retirement&mdash;we've already included those for you.
          </Text>
        </div>
        <div style={{ width: '100%' }}>
          <MultipleChoiceControl
            values={savingGoals}
            onChange={this.onChange}
            field_type="multi_choice"
            max_selections={3}
            options={['education', 'travel', 'start_business', 'buy_new_home', 'sabbatical', 'other_purchase']}
            option_data={{
              education: {
                label: 'Education Fund',
                description: 'Pay for private school or college tuition',
                image: require('images/Education.png'),
              },
              travel: {
                label: 'Travel',
                description: 'Save up for that dream trip around the world',
                image: require('images/Travel.png'),
              },
              start_business: {
                label: 'Starting a business',
                description: "Initial investment, and a cushion for while you're getting started",
                image: require('images/StartBusiness.png'),
              },
              buy_new_home: {
                label: 'Buying a new home',
                description: 'Save for a down payment, and figure out what you can afford',
                image: require('images/BuyingHome.png'),
              },
              sabbatical: {
                label: 'Taking a sabbatical',
                description: 'Take the time you need to write, explore, and enrich your life',
                image: require('images/Sabbatical.png'),
              },
              other_purchase: {
                label: 'Other major purchase',
                description: 'Boats, cars, home renovation, or whatever else money can buy',
                image: require('images/MajorPurchase.png'),
              },
            }}
          />
        </div>
      </DynamicWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    qna_hash: state.onboarding.qna_hash,
    qna_stack: state.onboarding.qna_stack,
  };
}

export default connect(mapStateToProps, { backOnboarding, continueOnboarding, pathAware })(SavingGoals);
